import { FormattedMessage, useIntl } from 'react-intl';
import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import { runInBackgroundCallback } from '../../../../configuration/setup/backgroundActions';
import Button from '@rio-cloud/rio-uikit/Button';
import InfoDialog from '@rio-cloud/rio-uikit/InfoDialog';
import { FunctionComponent } from 'react';

type CommonBulkSelectionDropdownProps = {
    addFilterResultToSelection: () => Promise<void>;
    removeFilterResultFromSelection: () => Promise<void>;
    clearSelection: () => void;
    hasTooManyFilterResultsError: boolean;
    resetTooManyFilterResultsError: () => void;
    maxSelectionSize: number;
};

export const BulkSelectionDropdown = ({
    addFilterResultToSelection,
    removeFilterResultFromSelection,
    clearSelection,
    hasTooManyFilterResultsError,
    resetTooManyFilterResultsError,
    maxSelectionSize,
}: CommonBulkSelectionDropdownProps) => {
    const intl = useIntl();

    return (
        <>
            <ButtonDropdown
                title={
                    <span
                        className="rioglyph rioglyph-checkboxes"
                        aria-label={intl.formatMessage({
                            id: 'outboundOrderBook.bulkSelection.selectionActions',
                        })}
                    />
                }
                iconOnly
                variant="outline"
                items={[
                    {
                        value: (
                            <FormattedMessage
                                key="foo"
                                id="outboundOrderBook.bulkSelection.addFilterResultToSelection"
                            />
                        ),
                        onSelect: runInBackgroundCallback(addFilterResultToSelection),
                    },
                    {
                        value: (
                            <FormattedMessage
                                key="baa"
                                id="outboundOrderBook.bulkSelection.removeFilterResultFromSelection"
                            />
                        ),
                        onSelect: runInBackgroundCallback(removeFilterResultFromSelection),
                    },
                    {
                        divider: true,
                    },
                    {
                        value: <FormattedMessage key="zuu" id="outboundOrderBook.bulkSelection.clearSelection" />,
                        onSelect: clearSelection,
                    },
                ]}
            />
            <TooManyFilterResultsInfoDialog
                show={hasTooManyFilterResultsError}
                onClose={resetTooManyFilterResultsError}
                maxSelectionSize={maxSelectionSize}
            />
        </>
    );
};

type TooManyFilterResultsInfoDialogProps = {
    show: boolean;
    onClose: () => void;
    maxSelectionSize: number;
};

export const TooManyFilterResultsInfoDialog: FunctionComponent<TooManyFilterResultsInfoDialogProps> = ({
    show,
    onClose,
    maxSelectionSize,
}) => (
    <InfoDialog
        show={show}
        onClose={onClose}
        content={
            <div className="text-center">
                <div className="margin-bottom-25">
                    <h2>
                        <FormattedMessage id="outboundOrderBook.bulkSelection.title" />
                    </h2>
                    <p className="margin-25">
                        <FormattedMessage
                            id="outboundOrderBook.bulkSelection.tooLargeSelection"
                            values={{ _newLine: <br />, maxCount: maxSelectionSize }}
                        />
                    </p>
                </div>
                <Button className="margin-bottom-20" onClick={onClose}>
                    <FormattedMessage id="outboundOrderBook.common.button.close" />
                </Button>
            </div>
        }
    />
);
